//프로필 입력 폼 타입
export enum ProfileInfo {
  BASIC_INFO = 'BASIC_INFO',
  PREFER = 'PREFER',
  EDU = 'EDU',
  CAREER = 'CAREER',
  PROJECT = 'PROJECT',
  SKILL = 'SKILL',
  EXPERIENCE = 'EXPERIENCE',
  PRIZE = 'PRIZE',
  MILITARY_PREFERENCE = 'MILITARY_PREFERENCE',
  ATTACHED_FILE = 'ATTACHED_FILE',
}

export type ProfileInfoType = keyof typeof ProfileInfo;
export type ProfileOverlayType = keyof typeof ProfileInfo | null;
